import { Box, Modal } from "@mui/material";
import React, { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MyContext } from "../../hooks/useContextProvider";

const Login = ({ open, setOpen, referralCode }) => {
  const { token, updateToken, callCartDetails, callWishListApi } =
    useContext(MyContext);
  const [step, setStep] = useState(
    referralCode !== "" && referralCode ? "step2" : "step1"
  );
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [signUpInputData, setSignUpInputData] = useState({
    email: "",
    password: "",
    name: "",
    mobileNo: "",
    referralCode: referralCode !== "" && referralCode ? referralCode : "",
  });
  const RESEND_TIME = 20; // seconds
  const [seconds, setSeconds] = useState(0);
  console.log("signUpInputData: ", signUpInputData);
  const [signUpInputDataError, setSignUpInputDataError] = useState({
    email: false,
    password: false,
    name: false,
    mobileNo: false,
    referralCode: false,
  });
  const [loginInputData, setLoginInputData] = useState({
    email: "",
    password: "",
  });
  const [loginInputDataError, setLoginInputDataError] = useState({
    email: false,
    password: false,
  });
  const [loading, setLoading] = useState(false);
  const [loginShowPassword, setLoginShowPassword] = useState(false);
  const [signUpShowPassword, setSignUpShowPassword] = useState(false);
  const [userDetails, setUserDetails] = useState(
    localStorage.getItem("userDetails") || ""
  );

  const [otp, setOtp] = useState("");
  const [otpSend, setOtpSend] = useState(false);
  const [otpVerify, setOtpVerify] = useState(false);

  const [otpLogin, setOtpLogin] = useState("");
  const [otpLoginSend, setOtpLoginSend] = useState(false);
  const [otpLoginVerify, setOtpLoginVerify] = useState(false);

  const navigate = useNavigate();
  const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;
  function isValidEmail(email) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  }
  let timer;

  useEffect(() => {
    if (seconds <= 0) return;

    const interval = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!forgotPasswordEmail) {
      toast.error("Please enter your email");
      return;
    }

    if (!isValidEmail(forgotPasswordEmail)) {
      toast.error("Please enter a valid email");
      return;
    }

    setLoading(true);

    // Send OTP API call
    const formData = new FormData();
    formData.append("email", forgotPasswordEmail);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}forgotsendotp?clientId=${process.env.REACT_APP_Client_Id}`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.status) {
        toast.success("OTP sent successfully");
        setStep("forgotPasswordOtp");
      } else {
        toast.error(data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("There was an error, Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otpInput) {
      toast.error("Please enter OTP");
      return;
    }

    setLoading(true);

    // Verify OTP API call
    const formData = new FormData();
    formData.append("customerEmail", forgotPasswordEmail);
    formData.append("otp", otpInput);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}verifyotp?clientId=${process.env.REACT_APP_Client_Id}`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.status) {
        toast.success("OTP verified successfully");
        setStep("newPassword");
      } else {
        toast.error(data.message || "Invalid OTP");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("There was an error, Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;

    if (!newPassword) {
      toast.error("Please enter a new password");
      return;
    }

    if (!passwordRegex.test(newPassword)) {
      toast.error(
        "Password must contain at least one uppercase, one lowercase, one symbol, and one number, with minimum 8 characters"
      );
      return;
    }

    setLoading(true);

    // Reset Password API call
    const formData = new FormData();
    formData.append("newPassword", newPassword);
    formData.append("username", forgotPasswordEmail);
    formData.append("clientId", process.env.REACT_APP_Client_Id);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}customerforgotpassword?clientId=${process.env.REACT_APP_Client_Id}`,
        {
          method: "POST",
          body: formData,
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data.status) {
        toast.success("Password reset successfully");
        setStep("step1");
        // Optionally reset all forgot password related states
        setForgotPasswordEmail("");
        setOtpInput("");
        setNewPassword("");
      } else {
        toast.error(data.message || "Failed to reset password");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      toast.error("There was an error, Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleLoginSendOtp = async (e) => {
    e.preventDefault();
    if (loginInputData?.email?.length !== 10) {
      toast.error("Please Enter a Proper Mobile No!", { toastId: "mobileErr" });
      setLoginInputDataError({ ...loginInputDataError, email: true });
    } else {
      const formData = new FormData();
      formData.append("customerMobile", "+91" + loginInputData?.email);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}sendwhatsappotp`,
          {
            method: "POST",
            body: formData,
          }
        );

        const data = await response.json();

        if (data.status) {
          toast.success("OTP sent successfully");
          setOtpLoginSend(true);
          setSeconds(RESEND_TIME);
        } else {
          toast.error(data.message || "Failed to Send otp");
          setOtpLoginSend(false);
        }
      } catch (error) {
        toast.error("There was an error, Please try again later.");
        setOtpLoginSend(false);
      }
    }
  };

  const handleLoginVerifyOtp = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (otpLogin?.length !== 6) {
      toast.error("Please Enter a Proper OTP!");
    } else {
      const formData = new FormData();
      formData.append("customerMobile", "+91" + loginInputData?.email);
      formData.append("otp", otpLogin);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}verifywhatsappotp`,
          {
            method: "POST",
            body: formData,
          }
        );

        const data = await response.json();

        if (data.status) {
          toast.success("OTP verified successfully");
          setOtpLoginVerify(true);
          handleLoginAfterVerifyOTP();
        } else {
          toast.error(data.message || "Failed to verify otp");
          setOtpLoginVerify(false);
        }
      } catch (error) {
        toast.error("There was an error, Please try again later.");
        setOtpLoginVerify(false);
      }
    }
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   if (!loginInputData?.email) {
  //     toast?.error("Email is Required!", { toastId: "EmailErr" });
  //     setLoginInputDataError({ ...loginInputDataError, email: true });
  //   } else if (!isValidEmail(loginInputData?.email)) {
  //     toast?.error("Please Enter a Email in Proper Format!", {
  //       toastId: "EmailErr2",
  //     });
  //     setLoginInputDataError({ ...loginInputDataError, email: true });
  //   } else if (!loginInputData?.password) {
  //     toast?.error("Please Enter a Password!", { toastId: "PasswordErr" });
  //     setLoginInputDataError({ ...loginInputDataError, password: true });
  //   } else {
  //     setLoading(true);

  //     let formData = new FormData();
  //     const token = localStorage.getItem("token");
  //     const ipAddress = localStorage.getItem("ipaddress");
  //     formData.append("username", loginInputData?.email);
  //     formData.append("password", loginInputData?.password);

  //     const requestOptions = {
  //       method: "POST",
  //       body: formData,
  //       headers: {
  //         Authorization: `Token ${token}`,
  //       },
  //     };

  //     fetch(
  //       `${process.env.REACT_APP_API_URL}customerlogin?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
  //       requestOptions
  //     )
  //       .then((response) => response.json())
  //       .then((data) => {
  //         if (
  //           data &&
  //           (data.detail === "The Token is expired" ||
  //             data.message === "Invalid token" || data.message === "Invalid Credentials.")
  //         ) {
  //           localStorage.clear();
  //           navigate("/");
  //           // window.location.reload();
  //         }
  //         if (data && data.status) {
  //           toast.success("Login Successfully");

  //           updateToken(data?.refresh);
  //           updateUserDetails(JSON.stringify(data?.user));
  //           localStorage.setItem("invoiceTemplate", JSON.stringify(data?.active_invoice_Data)
  //           );
  //           closeModal();
  //           setLoading(false);
  //           callCartDetails();
  //           callWishListApi();
  //           // if (customOpenModal) {
  //           //   handleOnCartClickOnLoginModal();
  //           //   if (setOpenLoginModal) {
  //           //     setOpenLoginModal(false);
  //           //   }
  //           // }
  //         } else if (data.message !== "Invalid token") {
  //           toast.error(data?.message);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log("error: ", error);
  //         setLoading(false);
  //         setTimeout(() => {
  //           toast.error("There was an error, Please try again later.", {
  //             position: "top-right",
  //             autoClose: 5000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //             progress: undefined,
  //           });
  //         }, 1000);
  //       });
  //   }
  // };

  const handleLoginAfterVerifyOTP = async () => {
    let formData = new FormData();
    const token = localStorage.getItem("token");
    const ipAddress = localStorage.getItem("ipaddress");
    formData.append("mobile", "+91" + loginInputData?.email);

    const requestOptions = {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Token ${token}`,
      },
    };

    fetch(
      `${process.env.REACT_APP_API_URL}customerloginotp?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data &&
          (data.detail === "The Token is expired" ||
            data.message === "Invalid token" ||
            data.message === "Invalid Credentials.")
        ) {
          localStorage.clear();
          navigate("/");
          // window.location.reload();
        }
        if (data && data.status) {
          toast.success("Login Successfully");

          updateToken(data?.refresh);
          updateUserDetails(JSON.stringify(data?.user));
          localStorage.setItem(
            "invoiceTemplate",
            JSON.stringify(data?.active_invoice_Data)
          );
          closeModal();
          setLoading(false);
          callCartDetails();
          callWishListApi();
          // if (customOpenModal) {
          //   handleOnCartClickOnLoginModal();
          //   if (setOpenLoginModal) {
          //     setOpenLoginModal(false);
          //   }
          // }
        } else if (data.message !== "Invalid token") {
          toast.error(data?.message);
        }
      })
      .catch((error) => {
        console.log("error: ", error);
        setLoading(false);
        setTimeout(() => {
          toast.error("There was an error, Please try again later.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }, 1000);
      });
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    if (signUpInputData?.mobileNo?.length !== 10) {
      toast.error("Please Enter a Proper Mobile No!", { toastId: "mobileErr" });
      setSignUpInputDataError({ ...signUpInputDataError, mobileNo: true });
    } else {
      const formData = new FormData();
      formData.append("customerMobile", "+91" + signUpInputData?.mobileNo);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}sendwhatsappotpsignup`,
          {
            method: "POST",
            body: formData,
          }
        );

        const data = await response.json();

        if (data.status) {
          toast.success("OTP sent successfully");
          setOtpSend(true);
          setSeconds(RESEND_TIME);
        } else {
          toast.error(data.message || "Failed to Send otp");
          setOtpSend(false);
        }
      } catch (error) {
        toast.error("There was an error, Please try again later.");
        setOtpSend(false);
      }
    }
  };

  const handleSingupVerifyOtp = async (e) => {
    e.preventDefault();
    if (otp?.length !== 6) {
      toast.error("Please Enter a Proper OTP!");
    } else {
      const formData = new FormData();
      formData.append("customerMobile", "+91" + signUpInputData?.mobileNo);
      formData.append("otp", otp);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}verifywhatsappotp`,
          {
            method: "POST",
            body: formData,
          }
        );

        const data = await response.json();

        if (data.status) {
          toast.success("OTP verified successfully");
          setOtpVerify(true);
        } else {
          toast.error(data.message || "Failed to verify otp");
          setOtpVerify(false);
        }
      } catch (error) {
        toast.error("There was an error, Please try again later.");
        setOtpVerify(false);
      }
    }
  };

  async function handleSignup(e) {
    e.preventDefault();

    if (!signUpInputData?.name) {
      toast?.error("Name is Required!", { toastId: "NameErr" });
      setSignUpInputDataError({ ...signUpInputDataError, name: true });
    } else if (signUpInputData?.name?.length <= 2) {
      toast?.error("Please Enter a Full Name!", { toastId: "NameErr2" });
      setSignUpInputDataError({ ...signUpInputDataError, name: true });
    } else if (!signUpInputData?.email) {
      toast?.error("Email is Required!", { toastId: "EmailErr" });
      setSignUpInputDataError({ ...signUpInputDataError, email: true });
    } else if (!isValidEmail(signUpInputData?.email)) {
      toast?.error("Please Enter a Email in Proper Format!", {
        toastId: "EmailErr2",
      });
      setSignUpInputDataError({ ...signUpInputDataError, email: true });
    } else if (!signUpInputData?.mobileNo) {
      toast.error("Please Enter a Mobile No!", { toastId: "mobileErr" });
      setSignUpInputDataError({ ...signUpInputDataError, mobileNo: true });
    } else if (signUpInputData?.mobileNo?.length !== 10) {
      toast.error("Please Enter a Proper Mobile No!", { toastId: "mobileErr" });
      setSignUpInputDataError({ ...signUpInputDataError, mobileNo: true });
    }
    // else if (!signUpInputData?.password) {
    //   toast?.error("Please Enter a Password!", { toastId: "PasswordErr" });
    //   setSignUpInputDataError({ ...signUpInputDataError, password: true });
    // } else if (!passwordRegex.test(signUpInputData?.password)) {
    //   toast?.error(
    //     "Please Enter a Password in Proper Format!, Password  contains at least one uppercase, one lowercase, one Symbol  and one number",
    //     { toastId: "PasswordErr2" }
    //   );
    //   setSignUpInputDataError({ ...signUpInputDataError, password: true });
    // }
    else {
      setLoading(true);
      const token = localStorage.getItem("token");
      const ipAddress = localStorage.getItem("ipaddress");
      let formData = new FormData();
      formData.append("customerName", signUpInputData?.name);
      formData.append("customerEmail", signUpInputData?.email);
      formData.append("customerMobile", `+91${signUpInputData?.mobileNo}`);
      formData.append("password", signUpInputData?.password);
      formData.append("clientId", process.env.REACT_APP_Client_Id);
      formData.append("created_by", "Customer");
      if (signUpInputData?.referralCode !== "" || referralCode) {
        formData.append("referralCode", signUpInputData?.referralCode);
      }

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Token ${token}`,
        },
      };
      fetch(
        `${process.env.REACT_APP_API_URL}customersignup?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((data) => {
          if (
            data &&
            (data.detail === "The Token is expired" ||
              data.message === "Invalid token" ||
              data.message === "Invalid Credentials.")
          ) {
            localStorage.clear();
            navigate("/");
            // window.location.reload();
          }
          if (data && data.status) {
            setSignUpInputData({
              agreePolicy: false,
              email: "",
              name: "",
              mobileNo: "",
              password: "",
              referralCode: "",
            });
            toast.success("SignUp Successfully!");
            setLoading(false);
            setStep("step1");
          }
          if (data && data.status === false) {
            toast.error(data?.message);
            setLoading(false);
          }
          if (
            data &&
            data.status === false &&
            data.message === "Invalid Referral Code."
          ) {
            setSignUpInputDataError({
              ...signUpInputDataError,
              referralCode: true,
            });
            toast.error("Invalid Referral Code.");
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log("error: ", error);
          setLoading(false);
          setTimeout(() => {
            toast.error("There was an error, Please try again later.", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }, 1000);
        });
    }
  }

  function closeModal() {
    document
      .getElementById("login-modal")
      ?.classList?.remove("ReactModal__Content--after-open");

    if (document?.querySelector(".ReactModal__Overlay")) {
      document.querySelector(".ReactModal__Overlay").style.opacity = "0";
    }

    timer = setTimeout(() => {
      setOpen(false);
      // if (setOpenLoginModal) {
      //   setOpenLoginModal(false);
      // }
    }, 350);
  }

  const updateUserDetails = (newData) => {
    setUserDetails(newData);
    localStorage.setItem("userDetails", newData);
  };

  const handleGuestLogin = () => {
    localStorage.setItem("guestMode", true);
    closeModal();
  };
  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="login-modal"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          position: "absolute",
          flexDirection: "column",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxWidth: 500,
          width: "100%",
          borderRadius: 2,
          border: "none",
          outline: "none",
          background: "white",
        }}
      >
        {step === "step1" && (
          <main class="login-whole">
            <div class="login-section">
              <div class="login">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: 37,
                      textAlign: "center",
                      paddingTop: 16,
                    }}
                    className="unna-regular"
                  >
                    Welcome Back
                  </p>
                </div>

                <form class="form" style={{ marginTop: 0 }}>
                  <div class="flex-column">
                    <label>Mobile No. * </label>
                  </div>
                  <div class="inputForm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <input
                      type="text"
                      className={`form-control border-none bg-white ${
                        loginInputDataError?.email && "border-danger"
                      }`}
                      style={{
                        backgroundColor: "white",
                        padding: "0px 20px",
                        border: "none",
                        border: "none",
                      }}
                      placeholder="Enter your Mobile No"
                      autoComplete="newpassword"
                      class="input"
                      id="email"
                      required
                      disabled={otpLoginSend}
                      value={loginInputData?.email}
                      onChange={(e) => {
                        if (e.target.value > 0 || e.target.value === "") {
                          setLoginInputData({
                            ...loginInputData,
                            email: e.target.value.trim(),
                          });

                          if (e.target.value.trim().length === 10) {
                            setLoginInputDataError({
                              ...loginInputDataError,
                              email: false,
                            });
                          } else {
                            setLoginInputDataError({
                              ...loginInputDataError,
                              email: true,
                            });
                          }
                        }
                      }}
                    />
                  </div>

                  {!otpLoginSend && (
                    <button
                      className="submit"
                      style={{ alignSelf: "auto", borderRadius: 8 }}
                      onClick={handleLoginSendOtp}
                      disabled={otpLoginSend}
                    >
                      {"Send OTP"}
                    </button>
                  )}
                  {otpLoginSend && !otpLoginVerify && (
                    <>
                      <div class="flex-column">
                        <label>OTP * </label>
                      </div>
                      <div class="inputForm">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <rect
                            x="4"
                            y="4"
                            width="16"
                            height="16"
                            rx="2"
                            ry="2"
                          ></rect>
                          <rect x="9" y="9" width="6" height="6"></rect>
                          <line x1="9" y1="1" x2="9" y2="4"></line>
                          <line x1="15" y1="1" x2="15" y2="4"></line>
                          <line x1="9" y1="20" x2="9" y2="23"></line>
                          <line x1="15" y1="20" x2="15" y2="23"></line>
                          <line x1="20" y1="9" x2="23" y2="9"></line>
                          <line x1="20" y1="14" x2="23" y2="14"></line>
                          <line x1="1" y1="9" x2="4" y2="9"></line>
                          <line x1="1" y1="14" x2="4" y2="14"></line>
                        </svg>
                        <input
                          className="input-text-cus form-control"
                          placeholder="Enter OTP"
                          value={otpLogin}
                          style={{
                            backgroundColor: "white",
                            padding: "0px 20px",
                            border: "none",
                            border: "none",
                          }}
                          onChange={(e) => {
                            setOtpLogin(e.target.value);
                          }}
                        />
                      </div>
                      {otpLoginSend && !otpLoginVerify  && (
                        <div class="flex-row">
                          <div
                            style={{
                              display: "flex",
                              gap: 10,
                              justifyContent: "flex-start",
                              alignItems: "center",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setOtpLoginSend(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 32 32"
                            >
                              <g data-name="Layer 3" id="Layer_3">
                                <path d="M25.7 4.3a2.9 2.9 0 0 0-4.1 0L6.2 19.7a1 1 0 0 0-.26.46l-1.9 6.3a1 1 0 0 0 1.25 1.25l6.3-1.9a1 1 0 0 0 .46-.26L27.4 10.2a2.9 2.9 0 0 0 0-4.1zm-15.1 19.9l-3.4 1 1-3.4L20.7 9.3l2.4 2.4zM24.5 8.5L22.1 6.1l1.5-1.5a.9.9 0 0 1 1.3 0l1.1 1.1a.9.9 0 0 1 0 1.3z" />
                              </g>
                            </svg>
                            <label
                              style={{
                                textWrap: "nowrap",
                                fontWeight: 600,
                                color: "#151717",
                                cursor: "pointer",
                              }}
                            >
                              Change Mobile No.{" "}
                            </label>
                          </div>
                          <span
                            class="span"
                            style={{
                              cursor: seconds > 0 ? "not-allowed" : "pointer",
                              color: seconds > 0 ? "#9ca3af" : "#2563eb",
                            }}
                            onClick={handleLoginSendOtp}
                            disabled={seconds > 0}
                          >
                            {seconds > 0
                              ? `Resend OTP (${seconds}s)`
                              : "Resend OTP"}
                          </span>
                        </div>
                      )}
                      <button
                        className="submit"
                        style={{ alignSelf: "auto", borderRadius: 8 }}
                        onClick={handleLoginVerifyOtp}
                      >
                        {"Verify OTP"}
                      </button>
                    </>
                  )}

                  {/* <div class="flex-column">
                    <label>Password * </label>
                  </div>
                  <div class="inputForm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      viewBox="-64 0 512 512"
                      height="20"
                    >
                      <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0"></path>
                      <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0"></path>
                    </svg>
                    <input
                      type={loginShowPassword ? "text" : "password"}
                      className={` input-text-cus form-control ${loginInputDataError?.password && "border-danger"
                        }`}
                      required
                      placeholder="Enter your Password"
                      class="input"
                      style={{
                        backgroundColor: "white",
                        padding: "0px 20px",
                        border: "none",
                      }}
                      id="password"
                      autoComplete="newpassword"
                      value={loginInputData?.password}
                      onChange={(e) => {
                        const passwordRegex =
                          /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;

                        setLoginInputData({
                          ...loginInputData,
                          password: e.target.value.trim(),
                        });
                        // if (
                        //   e.target.value.trim().length >= 3 &&
                        //   passwordRegex.test(e.target.value.trim())
                        // ) {
                        //   setLoginInputDataError({
                        //     ...loginInputDataError,
                        //     password: false,
                        //   });
                        // } else {
                        //   setLoginInputDataError({
                        //     ...loginInputDataError,
                        //     password: true,
                        //   });
                        // }
                      }}
                    />
                    <span className="show-password-input">
                      {loginShowPassword ? (
                        <i
                          class="fa fa-eye"
                          onClick={() =>
                            setLoginShowPassword(!loginShowPassword)
                          }
                          style={{ cursor: "pointer" }}
                        ></i>
                      ) : (
                        <i
                          class="fa fa-eye-slash"
                          onClick={() =>
                            setLoginShowPassword(!loginShowPassword)
                          }
                          style={{ cursor: "pointer" }}
                        ></i>
                      )}
                    </span>
                  </div> */}

                  <div class="flex-row">
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <input type="radio" />
                      <label style={{ textWrap: "nowrap" }}>Remember me </label>
                    </div>
                    <span
                      class="span"
                      onClick={() => {
                        setStep("forgotPasswordEmail");
                      }}
                    >
                      Forgot password?
                    </span>
                  </div>
                  {/* <button
                    class="submit"
                    style={{ alignSelf: "auto", borderRadius: 8 }}
                    onClick={handleLogin}
                  >
                    Sign In
                  </button> */}
                  <p
                    class="p"
                    onClick={() => {
                      setStep("step2");
                    }}
                  >
                    Don't have an account? <span class="span">Sign Up</span>
                  </p>
                </form>
              </div>
            </div>
          </main>
        )}

        {step === "step2" && (
          <main class="login-whole">
            <div class="login-section">
              <div class="login">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: 37,
                      textAlign: "center",
                      paddingTop: 16,
                    }}
                    className="unna-regular"
                  >
                    Create an Account
                  </p>
                </div>

                <form class="form" style={{ marginTop: 0 }}>
                  <div class="flex-column">
                    <label>Full Name * </label>
                  </div>
                  <div class="inputForm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      id="Capa_1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style={{ enableBackground: "new 0 0 512 512" }}
                      width="20"
                      height="20"
                    >
                      <g>
                        <circle cx="256" cy="128" r="128" />
                        <path d="M256,298.667c-105.99,0.118-191.882,86.01-192,192C64,502.449,73.551,512,85.333,512h341.333   c11.782,0,21.333-9.551,21.333-21.333C447.882,384.677,361.99,298.784,256,298.667z" />
                      </g>
                    </svg>
                    <input
                      placeholder="Enter your Name"
                      style={{
                        backgroundColor: "white",
                        padding: "0px 20px",
                        border: "none",
                        border: "none",
                      }}
                      className={` form-control ${
                        signUpInputDataError?.name && "border-danger"
                      }`}
                      required
                      value={signUpInputData?.name}
                      onChange={(e) => {
                        const nonNumericRegex = /^[A-Za-z\s]+$/;
                        if (
                          nonNumericRegex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          setSignUpInputData({
                            ...signUpInputData,
                            name: e.target.value,
                          });
                          if (e.target.value?.length >= 3) {
                            setSignUpInputDataError({
                              ...signUpInputDataError,
                              name: false,
                            });
                          } else {
                            setSignUpInputDataError({
                              ...signUpInputDataError,
                              name: true,
                            });
                          }
                        } else {
                          toast.error("Type characters only", {
                            toastId: "charctError",
                          });
                        }
                      }}
                    />
                  </div>
                  <div class="flex-column">
                    <label>Email * </label>
                  </div>
                  <div class="inputForm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      viewBox="0 0 32 32"
                      height="20"
                    >
                      <g data-name="Layer 3" id="Layer_3">
                        <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"></path>
                      </g>
                    </svg>
                    <input
                      type="email"
                      className={`form-control ${
                        signUpInputDataError?.email && "border-danger"
                      }`}
                      required
                      style={{
                        backgroundColor: "white",
                        padding: "0px 20px",
                        border: "none",
                        border: "none",
                      }}
                      placeholder="Enter your Email"
                      value={signUpInputData?.email}
                      onChange={(e) => {
                        setSignUpInputData({
                          ...signUpInputData,
                          email: e.target.value.trim(),
                        });

                        if (
                          e.target.value.trim().length >= 3 &&
                          isValidEmail(e.target.value.trim())
                        ) {
                          setSignUpInputDataError({
                            ...signUpInputDataError,
                            email: false,
                          });
                        } else {
                          setSignUpInputDataError({
                            ...signUpInputDataError,
                            email: true,
                          });
                        }
                      }}
                    />
                  </div>
                  <div class="flex-column">
                    <label>Mobile No. * </label>
                  </div>
                  <div class="inputForm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <input
                      placeholder="Enter your Mobile No."
                      style={{
                        backgroundColor: "white",
                        padding: "0px 20px",
                        border: "none",
                        border: "none",
                      }}
                      className={` form-control ${
                        signUpInputDataError?.mobileNo && "border-danger"
                      }`}
                      required
                      disabled={otpSend}
                      type="number"
                      value={signUpInputData?.mobileNo}
                      onChange={(e) => {
                        if (e.target.value > 0 || e.target.value === "") {
                          setSignUpInputData({
                            ...signUpInputData,
                            mobileNo: e.target.value,
                          });

                          if (e.target.value?.length === 10) {
                            setSignUpInputDataError({
                              ...signUpInputDataError,
                              mobileNo: false,
                            });
                          } else {
                            setSignUpInputDataError({
                              ...signUpInputDataError,
                              mobileNo: true,
                            });
                          }
                        }
                      }}
                    />
                  </div>

                  {!otpSend && (
                    <button
                      className="submit"
                      style={{ alignSelf: "auto", borderRadius: 8 }}
                      onClick={handleSendOtp}
                      disabled={otpSend}
                    >
                      {"Send OTP"}
                    </button>
                  )}

                  {otpSend && !otpVerify && (
                    <>
                      <div class="flex-column">
                        <label>OTP * </label>
                      </div>
                      <div class="inputForm">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#000000"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <rect
                            x="4"
                            y="4"
                            width="16"
                            height="16"
                            rx="2"
                            ry="2"
                          ></rect>
                          <rect x="9" y="9" width="6" height="6"></rect>
                          <line x1="9" y1="1" x2="9" y2="4"></line>
                          <line x1="15" y1="1" x2="15" y2="4"></line>
                          <line x1="9" y1="20" x2="9" y2="23"></line>
                          <line x1="15" y1="20" x2="15" y2="23"></line>
                          <line x1="20" y1="9" x2="23" y2="9"></line>
                          <line x1="20" y1="14" x2="23" y2="14"></line>
                          <line x1="1" y1="9" x2="4" y2="9"></line>
                          <line x1="1" y1="14" x2="4" y2="14"></line>
                        </svg>
                        <input
                          className="input-text-cus form-control"
                          placeholder="Enter OTP"
                          value={otp}
                          style={{
                            backgroundColor: "white",
                            padding: "0px 20px",
                            border: "none",
                            border: "none",
                          }}
                          onChange={(e) => {
                            setOtp(e.target.value);
                          }}
                        />
                      </div>
                      <div class="flex-row">
                        <div
                          style={{
                            display: "flex",
                            gap: 10,
                            justifyContent: "flex-start",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setOtpSend(false);
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 32 32"
                          >
                            <g data-name="Layer 3" id="Layer_3">
                              <path d="M25.7 4.3a2.9 2.9 0 0 0-4.1 0L6.2 19.7a1 1 0 0 0-.26.46l-1.9 6.3a1 1 0 0 0 1.25 1.25l6.3-1.9a1 1 0 0 0 .46-.26L27.4 10.2a2.9 2.9 0 0 0 0-4.1zm-15.1 19.9l-3.4 1 1-3.4L20.7 9.3l2.4 2.4zM24.5 8.5L22.1 6.1l1.5-1.5a.9.9 0 0 1 1.3 0l1.1 1.1a.9.9 0 0 1 0 1.3z" />
                            </g>
                          </svg>
                          <label
                            style={{
                              textWrap: "nowrap",
                              fontWeight: 600,
                              color: "#151717",
                              cursor: "pointer",
                            }}
                          >
                            Change Mobile No.{" "}
                          </label>
                        </div>
                        <span
                          class="span"
                          style={{
                            cursor: seconds > 0 ? "not-allowed" : "pointer",
                            color: seconds > 0 ? "#9ca3af" : "#2563eb",
                          }}
                          onClick={handleSendOtp}
                          disabled={seconds > 0}
                        >
                          {seconds > 0
                            ? `Resend OTP (${seconds}s)`
                            : "Resend OTP"}
                        </span>
                      </div>
                      <button
                        className="submit"
                        style={{ alignSelf: "auto", borderRadius: 8 }}
                        onClick={handleSingupVerifyOtp}
                      >
                        {"Verify OTP"}
                      </button>
                    </>
                  )}

                  {/* <div class="flex-column">
                    <label>Password * </label>
                  </div>
                  <div class="inputForm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      viewBox="-64 0 512 512"
                      height="20"
                    >
                      <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0"></path>
                      <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0"></path>
                    </svg>
                    <input
                      type={signUpShowPassword ? "text" : "password"}
                      className={`input-text-cus form-control ${signUpInputDataError?.password && "border-danger"
                        }`}
                      required
                      placeholder="Enter your Password"
                      value={signUpInputData?.password}
                      style={{
                        backgroundColor: "white",
                        padding: "0px 20px",
                        border: "none",
                        border: "none",
                      }}
                      onChange={(e) => {
                        const passwordRegex =
                          /^(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;

                        setSignUpInputData({
                          ...signUpInputData,
                          password: e.target.value.trim(),
                        });
                        if (
                          e.target.value.trim().length >= 3 &&
                          passwordRegex.test(e.target.value.trim())
                        ) {
                          setSignUpInputDataError({
                            ...signUpInputDataError,
                            password: false,
                          });
                        } else {
                          setSignUpInputDataError({
                            ...signUpInputDataError,
                            password: true,
                          });
                        }
                      }}
                    />
                    <span className="show-password-input">
                      {signUpShowPassword ? (
                        <i
                          class="fa fa-eye"
                          onClick={() =>
                            setSignUpShowPassword(!signUpShowPassword)
                          }
                          style={{ cursor: "pointer" }}
                        ></i>
                      ) : (
                        <i
                          class="fa fa-eye-slash"
                          onClick={() =>
                            setSignUpShowPassword(!signUpShowPassword)
                          }
                          style={{ cursor: "pointer" }}
                        ></i>
                      )}
                    </span>
                  </div> */}
                  {/* <p className="mb-0 mt-1">Password Must Contains :</p> */}
                  {/* <ul
                    className="mb-0"
                    style={{
                      marginTop: 1,
                      marginLeft: 17,
                      fontSize: 12,
                      listStyle: "disc",
                    }}
                  > */}
                  {/* <p style={{ 'fontSize': '12px' }}>Password Must Contains : At least one lowercase letter, At least one uppercase letter, At least one number, Minimum 8 characters</p> */}
                  {/* <li>At least one uppercase letter</li>
                    <li>At least one number</li>
                    <li>Minimum 8 characters</li> */}
                  {/* </ul> */}

                  <div class="flex-column">
                    <label>Referral Code</label>
                  </div>
                  <div class="inputForm">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#000000"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <rect
                        x="4"
                        y="4"
                        width="16"
                        height="16"
                        rx="2"
                        ry="2"
                      ></rect>
                      <rect x="9" y="9" width="6" height="6"></rect>
                      <line x1="9" y1="1" x2="9" y2="4"></line>
                      <line x1="15" y1="1" x2="15" y2="4"></line>
                      <line x1="9" y1="20" x2="9" y2="23"></line>
                      <line x1="15" y1="20" x2="15" y2="23"></line>
                      <line x1="20" y1="9" x2="23" y2="9"></line>
                      <line x1="20" y1="14" x2="23" y2="14"></line>
                      <line x1="1" y1="9" x2="4" y2="9"></line>
                      <line x1="1" y1="14" x2="4" y2="14"></line>
                    </svg>
                    <input
                      className="input-text-cus form-control"
                      placeholder="Enter Referral Code"
                      value={signUpInputData?.referralCode}
                      style={{
                        backgroundColor: "white",
                        padding: "0px 20px",
                        border: "none",
                        border: "none",
                      }}
                      onChange={(e) => {
                        setSignUpInputData({
                          ...signUpInputData,
                          referralCode: e.target.value,
                        });
                        setSignUpInputDataError({
                          ...signUpInputDataError,
                          referralCode: false,
                        });
                      }}
                    />
                  </div>

                  {otpSend && otpVerify && (
                    <button
                      type="submit"
                      class="button-submit"
                      disabled={
                        // !signUpInputData?.email ||
                        // !signUpInputData?.name ||
                        // !signUpInputData?.password ||
                        // !signUpInputData?.agreePolicy ||
                        // !signUpInputDataError?.email ||
                        // !signUpInputDataError?.password ||
                        // signUpInputDataError?.name ||
                        loading
                      }
                      onClick={handleSignup}
                    >
                      Sign Up
                    </button>
                  )}
                  <p
                    onClick={() => {
                      setStep("step1");
                    }}
                    class="p"
                  >
                    Already have an account? <span class="span">Sign In</span>
                  </p>
                </form>
              </div>
            </div>
          </main>
        )}

        {/* Forgot Password Email Step */}
        {step === "forgotPasswordEmail" && (
          <main className="login-whole">
            <div className="login-section">
              <div className="login">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: 37,
                      textAlign: "center",
                      paddingTop: 16,
                    }}
                    className="unna-regular"
                  >
                    Forgot Password
                  </p>
                </div>

                <form className="form" style={{ marginTop: 0 }}>
                  <div className="flex-column">
                    <label>Email Address * </label>
                  </div>
                  <div>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 32 32" height="20">
                      <g data-name="Layer 3" id="Layer_3">
                        <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"></path>
                      </g>
                    </svg> */}
                    <input
                      type="email"
                      className="form-control border-none bg-white"
                      placeholder="Enter your Email"
                      value={forgotPasswordEmail}
                      onChange={(e) =>
                        setForgotPasswordEmail(e.target.value.trim())
                      }
                    />
                  </div>

                  <button
                    className="submit"
                    style={{ alignSelf: "auto", borderRadius: 8 }}
                    onClick={handleForgotPassword}
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Send OTP"}
                  </button>

                  <p
                    className="p"
                    style={{ cursor: "pointer" }}
                    onClick={() => setStep("step1")}
                  >
                    Back to Login
                  </p>
                </form>
              </div>
            </div>
          </main>
        )}

        {/* OTP Verification Step */}
        {step === "forgotPasswordOtp" && (
          <main className="login-whole">
            <div className="login-section">
              <div className="login">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: 37,
                      textAlign: "center",
                      paddingTop: 16,
                    }}
                    className="unna-regular"
                  >
                    Verify OTP
                  </p>
                </div>

                <form className="form" style={{ marginTop: 0 }}>
                  <div className="flex-column">
                    <label>OTP * </label>
                  </div>
                  <div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter OTP"
                      value={otpInput}
                      onChange={(e) => setOtpInput(e.target.value.trim())}
                    />
                  </div>

                  <button
                    className="submit"
                    style={{ alignSelf: "auto", borderRadius: 8 }}
                    onClick={handleVerifyOtp}
                    disabled={loading}
                  >
                    {loading ? "Verifying..." : "Verify OTP"}
                  </button>

                  <p
                    className="p"
                    onClick={() => setStep("forgotPasswordEmail")}
                  >
                    Resend OTP
                  </p>
                </form>
              </div>
            </div>
          </main>
        )}

        {/* New Password Step */}
        {step === "newPassword" && (
          <main className="login-whole">
            <div className="login-section">
              <div className="login">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      fontSize: 37,
                      textAlign: "center",
                      paddingTop: 16,
                    }}
                    className="unna-regular"
                  >
                    Reset Password
                  </p>
                </div>

                <form className="form" style={{ marginTop: 0 }}>
                  <div className="flex-column">
                    <label>New Password * </label>
                  </div>
                  <div class="inputForm">
                    <input
                      type={loginShowPassword ? "text" : "password"}
                      className="input-text-cus form-control"
                      placeholder="Enter New Password"
                      class="input"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value.trim())}
                    />
                    <span className="show-password-input">
                      {loginShowPassword ? (
                        <i
                          class="fa fa-eye"
                          onClick={() =>
                            setLoginShowPassword(!loginShowPassword)
                          }
                          style={{ cursor: "pointer" }}
                        ></i>
                      ) : (
                        <i
                          class="fa fa-eye-slash"
                          onClick={() =>
                            setLoginShowPassword(!loginShowPassword)
                          }
                          style={{ cursor: "pointer" }}
                        ></i>
                      )}
                    </span>
                  </div>

                  <p style={{ fontSize: "12px" }}>
                    Password Must Contains: At least one lowercase letter, At
                    least one uppercase letter, At least one number, Minimum 8
                    characters
                  </p>

                  <button
                    className="submit"
                    style={{ alignSelf: "auto", borderRadius: 8 }}
                    onClick={handleResetPassword}
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Reset Password"}
                  </button>
                </form>
              </div>
            </div>
          </main>
        )}
      </Box>
    </Modal>
  );
};

export default Login;
